import { PageViewPayload } from './eventTypes';

export function normalizeRoutePath(pathname: string): string {
  if (!pathname) {
    return '/';
  }

  let normalized = pathname.trim();
  if (!normalized.startsWith('/')) {
    normalized = `/${normalized}`;
  }

  if (normalized.length > 1 && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1);
  }

  return normalized;
}

export function createPageViewPayload(pathname: string, pageTitle?: string): PageViewPayload {
  return {
    page_path: normalizeRoutePath(pathname),
    page_title: pageTitle?.trim() || undefined,
    timestamp: new Date().toISOString(),
  };
}

